import Kardex from './Kardex';
export default Kardex;